import 'component/css/order.css';

import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

import API from 'service/api';
import Util, { printContent } from 'service/util';
import Protected from 'component/Protected';
import PopMessage from 'component/pop-msg/PopMessage';

import ContactList from 'component/ContactList';
import DatePicker from 'react-datepicker';

import A4OrderInvoice from 'view/print/A4OrderInvoice';

const OrderItemRow = ({orderItem: x}) =>
{
  const [delivery_dtm, setDeliveryDate] = useState(x.delivery_dtm);

  return (
    <tr>
      <td className="col-odritm-item-group" title={x.srv_grp}>{ x.grp_name }</td>
      <td className="col-odritm-item" title={x.item_id}>{ x.srv_name }</td>
      <td className="col-odritm-delivert-date">
        <DatePicker selected={delivery_dtm} onChange={d=>setDeliveryDate(x.delivery_dtm = d)}
          dateFormat="yyyy-MM-dd" />
      </td>
      <td className="col-odritm-unit-price">${ Util.nf2(x.unit_price) }</td>
      <td className="col-odritm-qty">{ x.qty }</td>
      <td className="col-odritm-discount">${ Util.nf2(x.discount) }</td>
      <td className="col-odritm-subtotal">
        ${ Util.nf2(x.unit_price * x.qty - x.discount) }
      </td>
    </tr>
  );
}


//==================================================================================================

const OrderDetailModal = ({order, refreshData}) =>
{
  const grand_total = order.items.reduce((r,i) => r + i.unit_price * i.qty - i.discount, 0);

  const [items, setItems] = useState([]);

  const [o_status,       setStatus     ] = useState(order.o_status);
  const [payment_type,   setPaymentType] = useState(order.payment_type);
  const [payment_amount, setPaidAmount ] = useState(order.payment_amount);
  const [payment_ref,    setPaymentRef ] = useState(order.payment_ref);
  const [srv_addr,       setAddress    ] = useState(order.srv_addr);
  const [remarks,        setRemarks    ] = useState(order.remarks);

  const editOrder = () =>
  {
    let dto = {
      ...order
      ,o_status, srv_addr, remarks
      ,payment_type, payment_amount, payment_ref
    };
    API.editOrder(dto).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '操作失敗', 'danger');
      else {
        PopMessage.show('成功', '成功', 'success');
        refreshData();
      }
    });
  }

  const deleteOrder = () =>
  {
    API.deleteOrder(order).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '操作失敗', 'danger');
      else {
        PopMessage.show('成功', '成功', 'success');
        refreshData();
      }
    });
  }

  const updateOrderItems = () =>
  {
    API.editOrderItem(items).then(resp => {
      if (!resp.success)
        PopMessage.show(resp.msg, '操作失敗', 'danger');
      else {
        PopMessage.show('成功', '成功', 'success');
        refreshData();
      }
    });
  }

  const print = () =>
  {
    let page = <A4OrderInvoice order={order} />;
    printContent(page, { css: ['print-oiv.css'], delay: 1000 });
  }

  //------------------------------------------------
  // init
  useEffect(() => {
    if (order) {
      // deep clone data
      let _items = JSON.parse(JSON.stringify(order.items));

      // load dates
      for (let i = 0; i < _items.length; i++)
      {
        _items[i].create_dtm = new Date(_items[i].create_dtm);
        _items[i].order_dtm = new Date(_items[i].order_dtm);
        _items[i].delivery_dtm = !!_items[i].delivery_dtm
          ? new Date(_items[i].delivery_dtm)
          : null;
      }

      // trigger render
      setItems(_items);
    } else {
      setItems([]);
    }
  }, [order]);

  return (
    <div className="order-detail split-2">
      <section>
        <label className="field">
          <strong>編號</strong>
          <span>{order.company}{order.ix_yrmo}-{Util.LPAD(order.id, 7)}</span>
        </label>
        <label className="field">
          <strong>下單日期</strong>
          <span>{ Util.ShortDate(order.order_dtm) }</span>
        </label>
        <label className="field">
          <strong>客戶</strong>
          <span>{ order.cust_name } ({order.cust_id})</span>
        </label>
        <label className="field">
          <strong>聯絡方法</strong>
          <ContactList contacts={order.contacts} />
        </label>
        <label className="field">
          <strong>訂單狀態</strong>
          <select value={o_status} onChange={e=>setStatus(parseInt(e.target.value,10))}>
            <option value={ 0}>新訂單</option>
            <option value={ 1}>已取消</option>
            <option value={ 2}>已拒絕</option>
            <option value={ 8}>暫緩</option>
            <option value={ 9}>待跟進</option>
            <option value={10}>處理中</option>
            <option value={11}>送遞中</option>
            <option value={12}>已送遞</option>
          </select>
        </label>
        <label className="field">
          <strong>付款方法</strong>
          <select value={payment_type}
            onChange={e=>setPaymentType(e.target.value)}>
            <option value="0">0 - 未付款</option>
            <option value="C">C - 現金</option>
            <option value="T">T - 轉賬</option>
            <option value="Q">Q - 支票</option>
          </select>
        </label>
        <label className="field">
          <strong>參考編號</strong>
          <input value={payment_ref}
            onChange={e=>setPaymentRef(e.target.value)}
            onBlur={e=>setPaymentRef(e.target.value.trim())} />
        </label>
        <label className="field">
          <strong>應付金額</strong>
          <span>${ Util.nf2( grand_total ) }</span>
        </label>
        <label className="field">
          <strong>已收金額</strong>
          <input value={payment_amount} type="number" placeholder="HKD$"
            onChange={e=>setPaidAmount(parseFloat(e.target.value))} />
        </label>
        <label className="field">
          <strong>車牌</strong>
          <span>{ order.cd_license }</span>
        </label>
        <label className="field">
          <strong>車場</strong>
          <div>
            <div>{order.srv_dis}{order.srv_loc} - {order.name_zh} / {order.name_en}</div>
            <div>{order.srv_floor} {order.srv_psn}</div>
          </div>
        </label>
        <label className="field">
          <strong>地址</strong>
          <input value={srv_addr}
            onChange={e=>setAddress(e.target.value)}
            onBlur={e=>setAddress(e.target.value.trim())} />
        </label>
        <label className="field">
          <strong>備註</strong>
          <textarea value={remarks}
            onChange={e=>setRemarks(e.target.value)}
            onBlur={e=>setRemarks(e.target.value.trim())}>
          </textarea>
        </label>
        <Protected allow={['ADMIN','OPERATOR']}>
          <div className="action-panel">
            <button className="btn red" onClick={deleteOrder}>移除</button>
            <button className="btn blue" onClick={editOrder}>更新</button>
          </div>
        </Protected>
      </section>
      <section>
        <table className="data-table order-detail-items">
          <colgroup>
            <col width="120px" id="col-odritm-item-group" />
            <col width="auto"  id="col-odritm-item" />
            <col width="auto"  id="col-odritm-delivert-date" />
            <col width="auto"  id="col-odritm-unit-price" />
            <col width="auto"  id="col-odritm-qty" />
            <col width="auto"  id="col-odritm-discount" />
            <col width="auto"  id="col-odritm-subtotal" />
          </colgroup>
          <thead>
            <tr>
              <th className="col-odritm-item-group">分類</th>
              <th className="col-odritm-item">服務/商品</th>
              <th className="col-odritm-delivert-date">送遞日期</th>
              <th className="col-odritm-unit-price">單價</th>
              <th className="col-odritm-qty">數量</th>
              <th className="col-odritm-discount">折扣</th>
              <th className="col-odritm-subtotal">小計</th>
            </tr>
          </thead>
          <tbody>
          { items.map((itm, idx) =>
            <OrderItemRow key={idx} orderItem={itm} refreshData={refreshData} />
          )}
          </tbody>
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th>總計</th>
              <th>${ Util.nf2(grand_total) }</th>
            </tr>
          </tfoot>
        </table>
        <div className="action-panel">
          <div>
            <button className="btn white" onClick={print}>
              <FontAwesomeIcon icon={faPrint} />
              <span>列印發票</span>
            </button>
          </div>
          <Protected allow={['ADMIN','OPERATOR']}>
            <button className="btn blue" onClick={updateOrderItems}>修改訂單內容</button>
          </Protected>
        </div>
      </section>
    </div>
  );
}

export default OrderDetailModal;